import React from 'react';
import Criteria from './criteria';
import Benefit from './benefit';

export default function PartnerAuthorisedVAR() {
  return (
    <div className="grid grid-cols-1 font-sans">
      <Criteria></Criteria>
      <Benefit></Benefit>
    </div>
  );
}
